import { render, staticRenderFns } from "./creativity.vue?vue&type=template&id=ec754b26&scoped=true"
import script from "./creativity.vue?vue&type=script&lang=js"
export * from "./creativity.vue?vue&type=script&lang=js"
import style0 from "./creativity.vue?vue&type=style&index=0&id=ec754b26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec754b26",
  null
  
)

export default component.exports